export const environment = {
  production: true,
  apiUrl: "https://umyonba.site/api_umyocards/public/api/"
};


